// Подсказки страниц находятся выше боковой навигации (1300). Внутри окон
// antd дополнительно рассчитывает слой относительно родительского окна.
export const popupLayers = {
  Tooltip: { zIndexPopup: 1400 },
  Popover: { zIndexPopup: 1400 },
};
